import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) {
  }

  getCall(url,headers?,fullResponse?): Observable<any> {
      try {
        return this.http.get(url, headers).pipe(map((response: any) => {
          if (this.isResponseSuccessful(response)) {
            return fullResponse ? response : ( (response.body || response.body === 0) ? response.body : response.message);
          }
          if (response.statusCode === 500) {
            return response;
          }
          if (response.statusCode === 400) {
            return response;
          }
          if(response.length > 0 && !response.statusCode){
             return response;
          }
          if(response.status_code == 1000){
            return response.data ? response.data : response;
          }
          return null;
        }, error => {
          return null;
        }));
      } catch (error) {
        return of(null);
      }
  }

  postCall(url, data, headers?,fullResponse?): Observable<any> {
    try {
      return this.http.post(url, data, headers).pipe(map((response: any) => {
        if (this.isResponseSuccessful(response)) {
          return fullResponse ? response : (response.body ? response.body : response.message)
        }
        if (response.statusCode === 409) {
          return response;
        }
        if (response.statusCode === 400) {
          return response;
        }
        if(response.status_code == 1000){
          return response.data ? response.data : response;
        }
        if (response.status_code === 409) {
          return response.data ? response.data : response;
        }
        if (response.status_code === 400) {
          return response.data ? response.data : response;
        }
        if(response.status_code === 2000){
          return response.data ? response.data : response;
        }
        return null;
      }, error => {
        return null;
      }));
    } catch (error) {
      return of(null);
    }
}

  putCall(url, data, headers?,fullResponse?): Observable<any> {
    try {
      return this.http.put(url, data, headers).pipe(map((response: any) => {
        if (this.isResponseSuccessful(response)) {
          return  fullResponse ? response :(response.body ? response.body : response.message)
        }
        if(response.status_code == 1000){
          return response.data ? response.data : response;
        }
        if (response.statusCode === 400 || 102) {
          return response;
        }
        if (response.status_code === 409) {
          return response.data ? response.data : response;
        }
        if (response.status_code === 400) {
          return response.data ? response.data : response;
        }
        return null;
      }, error => {
        return null;
      }));
    } catch (error) {
      return of(null);
    }
  }

  deleteCall(url, headers?): Observable<any> {
    try {
      return this.http.delete(url, headers).pipe(map((response: any) => {
        if (this.isResponseSuccessful(response)) {
          return response.body ? response.body : response.message;
        }
        if(response.status_code == 1000){
          return response.data ? response.data : response;
        }
        return null
      }, error => {
        return null;
      }));
    } catch (error) {
      return of(null);
    }
  }

  patchCall(url, data, headers?): Observable<any> {
    try {
      return this.http.patch(url, data, headers).pipe(map((response: any) => {
        if (this.isResponseSuccessful(response)) {
          return response.body ? response.body : response.message;
        }
        if(response.status_code == 1000){
          return response.data ? response.data : response;
        }
        if(response.status_code === 2000){
          return response.data ? response.data : response;
        }
        return null;
      }, error => {
        return null;
      }));
    } catch (error) {
      return of(null);
    }
  }

  isResponseSuccessful(response) {
    return response.statusCode === 200 || response.statusCode === 201;
  }

}

